export default class Account {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.setupShopifyProvinceSelector();
      this.setupEventListeners();
    }
  }

  //===========================================================================
  // Toggles the account drawer open or closed
  //===========================================================================

  toggleAccountDrawer (e) {
    const $body = $('body');

    e.preventDefault();

    if ($body.hasClass('account-drawer-active')) {
      $body.removeClass('account-drawer-active');
    } else {
      $body.removeClass('mobile-nav-active');
      $body.removeClass('cart-drawer-active');
      $body.addClass('account-drawer-active');
    }
  }

  //===========================================================================
  // Deletes an address
  //===========================================================================

  deleteAddress(e) {
    const $el = $(e.currentTarget);
    const target = $el.data('target');
    const confirmMessage = $el.data('confirm-message');

    e.preventDefault();

    if (
      confirm(
        confirmMessage || 'Are you sure you wish to delete this address?'
      )
    ) {
      Shopify.postLink(target, {
        parameters: { _method: 'delete' }
      });
    }
  }

  //===========================================================================
  // Initializes the province selector for the address form.
  //===========================================================================

  setupShopifyProvinceSelector() {
    if (Shopify) {
      $('.js-address-country').each(function() {
        const $container = $(this);
        const countryId  = $container.data('country-id');
        const provinceId = $container.data('province-id');
        const provinceContainerId = $container.data('province-container-id');

        new Shopify.CountryProvinceSelector(
          countryId,
          provinceId,
          {
            hideElement: provinceContainerId
          }
        );
      });
    }
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(document).on('click', '.js-account-toggle', this.toggleAccountDrawer.bind(this));
    $(document).on('click', '.js-delete-address', this.deleteAddress.bind(this));
    $(document).on('historyChange', this.setupShopifyProvinceSelector.bind(this));
  }
}
